/**
 * Progressive Assets roster: first paint uses enrichment=skip, then full list.
 * If the user has unsaved edits when the full roster arrives, defer apply so
 * we do not clobber cells — but keep the payload so they can apply explicitly.
 */

export type EnrichedRosterApplyDecision = 'apply' | 'defer';

export function decideEnrichedRosterApply(hasUnsavedChanges: boolean): EnrichedRosterApplyDecision {
  return hasUnsavedChanges ? 'defer' : 'apply';
}

export function progressiveRosterBanner(params: {
  enriching: boolean;
  declaredCount: number;
  pendingFullCount: number | null;
}): string | null {
  if (params.pendingFullCount != null) {
    return `Full roster ready (${params.pendingFullCount} vehicles). Apply discards unsaved edits.`;
  }
  if (params.enriching) {
    return `Showing declared roster (${params.declaredCount}) — applying observed status…`;
  }
  return null;
}
